import React from "react";

// Chevron stack mark inspired by the DEPP C&M brand identity
export default function Logomark({ className = "", size = 40, accent = "#D4AF37" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-label="DEPP C&M"
    >
      {/* three stacked chevrons: dark navy bands with gold accents */}
      <defs>
        <linearGradient id="depp-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#F4F4F5" />
          <stop offset="100%" stopColor="#A1A1AA" />
        </linearGradient>
      </defs>

      {/* top chevron (gold accent) */}
      <path
        d="M10 22 L32 8 L54 22 L54 28 L32 14 L10 28 Z"
        fill={accent}
      />
      {/* middle chevron */}
      <path
        d="M10 34 L32 20 L54 34 L54 40 L32 26 L10 40 Z"
        fill="url(#depp-g)"
      />
      {/* bottom chevron */}
      <path
        d="M10 46 L32 32 L54 46 L54 52 L32 38 L10 52 Z"
        fill="url(#depp-g)"
      />
    </svg>
  );
}
